import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  selectCompletionStringDataStructure,
  setCompletionStringDataStructure,
} from "features/input/dataManagerSlice";

import NullFile from "./NullFile";
import { getWellCompletionStringInputConfig } from "service/wellCompletion";

function CompletionStringInput(props) {
  const { inputData } = props;

  const completionDataStructure = useSelector(
    selectCompletionStringDataStructure
  );
  const [columnDictionary, setColumnDictionary] = useState([]);

  let dispatch = useDispatch();

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    getWellCompletionStringInputConfig(
      (result) => {
        let tempColumn = result.map((item) => {
          return { id: item.id, header: item.name };
        });
        setColumnDictionary([{ id: -1, header: "N/A" }, ...tempColumn]);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  useEffect(() => {
    if (
      columnDictionary !== null &&
      columnDictionary.length > 0 &&
      inputData !== null
    ) {
      initDataStructure();
    }
  }, [columnDictionary, inputData]);

  function initDataStructure() {
    const initialSelection = inputData["headers"].map((x) => {
      let selectedCol = null;
      let header = x.trim().toLowerCase().replace(/\s/g, "_");
      let i = columnDictionary.findIndex(
        (e) =>
          header.startsWith(e.header) ||
          e.header.startsWith(header) ||
          header.includes(e.header) ||
          e.header.includes(header)
      );
      if (i !== -1) {
        selectedCol = columnDictionary[i].header;
      } else {
        selectedCol = columnDictionary[0].header;
      }
      return selectedCol;
    });
    dispatch(setCompletionStringDataStructure(initialSelection));
  }

  function handleChangeColumn(e, i) {
    const unpacked = completionDataStructure.map((el, index) => {
      if (index === i) {
        return e.target.value;
      } else {
        return el;
      }
    });
    dispatch(setCompletionStringDataStructure(unpacked));
  }

  return (
    <div className="table-container d-flex flex-column justify-content-start align-items-start">
      {inputData == null || completionDataStructure == null ? (
        <NullFile />
      ) : (
        <>
          <div className="table-header">
            {inputData["headers"].map((x, i) => {
              return (
                <div className="header-cell" key={i}>
                  {x}
                </div>
              );
            })}
          </div>
          <div className="table-header">
            {inputData["headers"].map((x, i) => {
              return (
                <div className="header-cell" key={i}>
                  <select
                    id={`attribute_id${i}`}
                    onChange={(e) => {
                      handleChangeColumn(e, i);
                    }}
                    value={completionDataStructure[i]}
                  >
                    {columnDictionary.map((y, j) => {
                      return (
                        <option key={i + "_" + j} value={y.header}>
                          {y.header}
                        </option>
                      );
                    })}
                  </select>
                </div>
              );
            })}
          </div>
          <div className="table-body">
            {inputData["data"].map((el, index) => {
              return (
                <div className="data-row" key={index}>
                  {el.map((val, subIndex) => {
                    return (
                      <div className="data-cell" key={index + "_" + subIndex}>
                        {val}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default CompletionStringInput;
